import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import MultiSelect from '@/shared/components/input/multiselect/MultiSelect';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import ItemsFilter from '@/shared/components/table/filters/ItemsFilter';
import config from '../../config';
import messages from './taskMessages';

export default class ChangeTaskTagsModal extends Component {
  state = {
    tags: [],
    selectedTags: [],
    selectedSubtask: null,
  };

  componentDidMount() {
    const { intl } = this.props;
    api.base.get(`${config.appUrls.tasks}/api/Tags`).then(({ data }) => {
      this.setState({
        tags: data.map(x => ({ ...x, label: x.name })),
      });
    }, handleHttpError(intl));
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
    subtasks: PropTypes.arrayOf(PropTypes.shape({})),
    addTags: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
    subtasks: null,
    addTags: true,
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  validate = () => {
    const { selectedTags } = this.state;
    if (!selectedTags || selectedTags.length === 0) return false;
    return true;
  };

  onSave = () => {
    const { selectedSubtask, selectedTags } = this.state;
    const { onSave, subtasks, addTags } = this.props;
    if (!this.validate()) return Promise.reject(new Error('invalid form'));

    const parameters = {
      tags: selectedTags,
      action: addTags ? 'add' : 'remove',
    };
    if (subtasks && subtasks.length > 0) {
      parameters.subtaskTemplateId = selectedSubtask;
    }

    return onSave(parameters);
  };

  onAddTag = tagName => {
    const trimmedName = tagName?.trim();
    if (!trimmedName) return;

    this.setState(({ tags, selectedTags }) => {
      if (selectedTags.some(x => x.name.toLowerCase() === trimmedName.toLowerCase())) return {}; // Already contains tag, nothing changed

      let tag = tags.find(x => x.name.toLowerCase() === trimmedName.toLowerCase());
      if (tag) {
        return { selectedTags: [...selectedTags, tag] };
      }
      tag = {
        name: trimmedName,
        label: trimmedName,
      };
      return { selectedTags: [...selectedTags, tag], tags: [...tags, tag] };
    });
  };
  subtaskChanged = e => {
    this.setState({ selectedSubtask: e.target.value || null });
  };

  onRemoveTag = ({ value: tag }) => {
    const trimmedName = tag?.name?.trim();
    if (!trimmedName) return;
    this.setState(({ selectedTags }) => ({
      selectedTags: selectedTags.filter(x => x.name.toLowerCase() !== trimmedName.toLowerCase()),
    }));
  };

  render() {
    const { show, intl, subtasks, addTags } = this.props;
    const { tags, selectedTags, selectedSubtask } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(addTags ? messages.AddTaskTags : messages.RemoveTaskTags)}
        show={show}
        onClose={this.closeModal}
        disabled={!this.validate()}
        onSave={this.onSave}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              {subtasks && subtasks.length > 0 ? (
                <div className="form-group">
                  <label className="control-label col-sm-3">
                    {intl.formatMessage(messages.Task)}
                  </label>
                  <div className="col-sm-6">
                    <select
                      onChange={this.subtaskChanged}
                      className="form-control form-field"
                      value={selectedSubtask || ''}
                    >
                      {!selectedSubtask && (
                        <option value="">{intl.formatMessage(messages.MainTask)}</option>
                      )}
                      {subtasks.map(subtask => (
                        <option key={subtask.id} value={subtask.id}>
                          {intl.formatMessage(
                            listItemMsg('taskTemplate', subtask.id, subtask.name),
                          )}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ) : null}
              <div className="form-group">
                <label className="control-label col-sm-3">
                  <FormattedMessage {...messages.Tags} />
                </label>
                <div className="col-sm-6">
                  <div className="margin20B">
                    {tags && (
                      <MultiSelect
                        placeholder={intl.formatMessage(messages.EnterTag)}
                        onItemSelected={t => this.onAddTag(t?.name)}
                        items={tags}
                        selectedItem={selectedTags}
                        onCreateItem={addTags ? this.onAddTag : undefined}
                        onItemRemoved={this.onRemoveTag}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
